<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-01 23:09:12
 * @LastEditors: ???
 * @LastEditTime: 2022-06-08 15:18:13
-->
<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="visible"
      width="30%"
      @close="close"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="validatorRules"
        label-width="120px"
        :inline="false"
        size="normal"
      >
        <el-form-item label="用户名" prop="userName">
          <el-input
            v-model.trim="form.userName"
            placeholder="请输入用户名(长度32字符内)"
            maxlength="32"
            style="width: 90%"
            @blur="loginAccountChange"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="realName">
          <el-input
            v-model.trim="form.realName"
            placeholder="请输入姓名(长度16字符内)"
            maxlength="16"
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="form.sex">
            <el-radio :label="0">女</el-radio>
            <el-radio :label="1">男</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input
            v-model.trim="form.mobile"
            placeholder="请输入手机号(长度11位数字)"
            maxlength="11"
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model.trim="form.email"
            placeholder="请输入邮箱(长度32字符内)"
            maxlength="32"
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleId">
          <el-select
            v-model="form.roleId"
            placeholder="请选择角色"
            style="width: 90%"
            clearable
          >
            <el-option
              v-for="item in roleOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="密码" prop="passWord" v-if="title === '新增'">
          <el-input
            type="password"
            v-model.trim="form.passWord"
            maxlength="20"
            placeholder="请输入密码"
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="生日" prop="birthday" v-if="title === '新增'">
          <el-input
            v-model.trim="form.birthday"
            maxlength="20"
            placeholder="请输入密码"
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="头像" prop="logourl" v-if="title === '新增'">
          <el-input
            v-model.trim="form.logourl"
            maxlength="20"
            placeholder="请输入密码"
            style="width: 90%"
          ></el-input>
        </el-form-item> -->
        <el-form-item
          label="再次确认密码"
          prop="passWord1"
          v-if="title === '新增'"
        >
          <el-input
            type="password"
            v-model.trim="form.passWord1"
            maxlength="20"
            placeholder="请再次输入密码"
            style="width: 90%"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="visible = false" size="mini">取消</el-button>
        <el-button type="primary" @click="handleOk" size="mini">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { httpAction } from '@/api/manage';
import {
  findByMobile,
  getRoleListAll,
  findByuserName,
  emailResetPassword,
} from '@/api/system';

import { listMixin } from '@/mixins/listMixin';

export default {
  components: {},
  mixins: [listMixin],
  props: {},
  data() {
    return {
      disableMixinCreated: true,
      roleOptions: [],
      title: '操作',
      visible: false,
      confirmLoading: false,
      form: {},
      validatorRules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { max: 32, message: '长度在 32 个字符以内', trigger: 'change' },
          // { validator: findByuserName, message: '用户名已存在', trigger: 'blur' }
        ],
        realName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { max: 16, message: '长度在16 个字符以内', trigger: 'change' },
        ],
        email: [{ max: 32, message: '长度在32 个字符以内', trigger: 'change' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        roleId: [{ required: true, message: '请选择角色', trigger: 'change' }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '请输入正确的手机号',
            trigger: 'blur',
          },
          // { validator: findByMobile, message: '手机号码已存在', trigger: 'blur' }
        ],
        userRoleIdsList: [
          { required: false, message: '请选择角色', trigger: 'change' },
        ],
        passWord1: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            pattern: /^(\w){6,20}$/,
            message: '密码由6-20位的字母、数字、下划线组成',
            trigger: 'blur',
          },
        ],
        passWord: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          {
            pattern: /^(\w){6,20}$/,
            message: '密码由6-20位的字母、数字、下划线组成',
            trigger: 'blur',
          },
        ],
      },
      url: {
        add: 'user/addUser',
        edit: 'user/updateUser',
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    loginAccountChange() {
      this.$refs.form.validateField('userName', (errorMessage) => {
        if (errorMessage) {
          return false;
        }
        let id = '';
        if (this.dialogTitle === '编辑') {
          id = this.form.id;
        }
        const params = {
          userName: this.form.userName,
          userId: id,
        };
        findByuserName(params)
          .then((res) => {
            if (res.code !== 200) {
              this.validateUserName = true;
              this.$message.warning('用户名不能重复');
            } else {
              this.validateUserName = false;
            }
          })
          .catch(() => {
            this.$refs.form.validateField('userName');
          });
      });
    },
    getRoleOptions() {
      getRoleListAll()
        .then((res1) => {
          this.roleOptions = res1.data.records;
        })
        .catch(() => {});
    },
    phoneChange() {
      this.$refs.form.validateField('mobile', (errorMessage) => {
        if (errorMessage) {
          return false;
        }
        let id = '';
        if (this.dialogTitle === '编辑') {
          id = this.form.id;
        }
        findByMobile({
          mobile: this.form.mobile,
          userId: id,
          mobileType: 2,
        })
          .then((res) => {
            if (res.code !== 200) {
              this.validatePhone = true;
              this.$message.warning('手机号码不能重复');
            } else {
              this.validatePhone = false;
            }
          })
          .catch(() => {
            this.$refs.form.validateField('mobile');
          });
      });
    },
    add() {
      this.edit({});
    },
    edit(record) {
      this.form = Object.assign({}, record);

      this.visible = true;
    },
    close() {
      this.$refs.form.resetFields();
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          const parms = {
            email: this.form.email,
            mobile: this.form.mobile,
            password: this.form.passWord,
            realName: this.form.realName,
            roleId: this.form.roleId,
            sex: this.form.sex,
            userName: this.form.userName,
            userType: 2,
          };
          if (!this.form.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post'; //put
            parms.userId = this.form.id;
          }
          httpAction(httpurl, parms, method)
            .then((res) => {
              if (res.code == 200) {
                that.$message.success('操作成功');
                that.$emit('ok');
              } else {
                that.$message.warning(res.msg);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
  },
  created() {
    this.getRoleOptions();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
}
</style>
